import axios from 'axios'

const ENDPOINT = '/api/internal/generator/assets'

const csrfToken = () => {
  const meta = document.getElementsByName('csrf-token')[0]
  return meta?.getAttribute('content')
}

// The internal API answers in snake_case and is not camelized, so map it here.
export const prepareAcquiredModelAsset = async (modelId) => {
  const response = await axios.post(
    ENDPOINT,
    { item_id: modelId },
    {
      headers: { 'X-CSRF-Token': csrfToken() },
      withCredentials: true,
    },
  )
  const { id, url, file_size: fileSize, format } = response.data

  return {
    assetId: id, url, fileSize, format,
  }
}
